(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["opium-card-colors"] && !Shopify.designMode) return;
  try {
    (function () {
    // Mouse only: on touch, a tap on a dot should just open that colour.
    if (!window.matchMedia('(hover: hover)').matches) return;

    function cardImage(dot) {
      const card = dot.closest('product-card');
      return card && card.querySelector('.card-gallery img');
    }

    document.addEventListener('pointerover', function (event) {
      const dot = event.target.closest && event.target.closest('.opium-card-colors__dot[data-image]');
      if (!dot) return;
      const img = cardImage(dot);
      if (!img) return;
      if (!img.dataset.opiumSrc) {
        img.dataset.opiumSrc = img.getAttribute('src') || '';
        img.dataset.opiumSrcset = img.getAttribute('srcset') || '';
      }
      img.removeAttribute('srcset');
      img.src = dot.dataset.image;
    });

    document.addEventListener('pointerout', function (event) {
      const list = event.target.closest && event.target.closest('.opium-card-colors');
      if (!list || list.contains(event.relatedTarget)) return;
      const img = cardImage(list);
      if (!img || !img.dataset.opiumSrc) return;
      img.src = img.dataset.opiumSrc;
      if (img.dataset.opiumSrcset) img.setAttribute('srcset', img.dataset.opiumSrcset);
      delete img.dataset.opiumSrc;
      delete img.dataset.opiumSrcset;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
